<template>
  <div class="home-page">
    <!-- 顶部标题栏 -->
    <div class="home-header">
      <div class="home-header-left">
        <img class="home-header-logo" src="/img/homenavlogo.png" alt="" onerror="this.style.display='none'" />
        <span class="home-header-title">{{ $t('index.header_title') }}</span>
      </div>
      <div class="home-header-right" @click="toLogin('/Personalreport')">
        <van-icon name="bar-chart-o" color="#e89ab3" size="22" />
      </div>
    </div>

    <!-- Banner -->
    <div class="banner-wrap">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="banner_img" :src="v.url" width="100%" height="260px">
            <template #loading>
              <van-loading type="circular" />
            </template>
            <template #error>
              <img src="/img/lotterybg.png" class="banner-fallback" alt="" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <!-- 公告 -->
    <div class="notice-wrap">
      <van-notice-bar
        class="notice-bar"
        color="#e89ab3"
        background="#fff"
        scrollable
        :text="notice"
      >
        <template #left-icon>
          <van-icon name="volume-o" color="#e89ab3" size="16" />
        </template>
      </van-notice-bar>
    </div>

    <!-- 快捷入口 -->
    <div class="quick-nav">
      <div
        v-for="item in quickNavItems"
        :key="item.path"
        class="quick-nav-item"
        @click="toLogin(item.path)"
      >
        <img :src="item.icon" alt="" class="quick-nav-icon" />
      </div>
    </div>

    <!-- 推荐列表 -->
    <div class="recommend-section">
      <div class="section-title">
        <span class="section-title-bar"></span>
        <span class="section-title-text">{{ $t('index.recommended_for_you') }}</span>
      </div>

      <div v-if="recommendLoading" class="recommend-loader-wrap">
        <div class="loader"></div>
      </div>

      <template v-else>
      <div
        v-for="(item, idx) in datalist"
        :key="item.id"
        class="yp-item"
        @click="toDetail(item.id, idx)"
      >
        <div class="yp-img-container">
          <div class="yp-photo">
            <img
              class="yp-img"
              :src="item.img_url"
              alt=""
              @error="$event.target.src = '/img/error.png'"
            />
            <span class="top-ribbon">TOP</span>
          </div>
          <div class="yp-name">{{ tr(item.xuanfei_name || item.name) }}</div>
        </div>

        <div class="yp-info">
          <div class="vip-row">
            <div class="vip-icon-container">
              <img class="vip-icon" src="/img/vip.png" alt="" />
              <div>VIP{{ item.vip || 3 }}</div>
            </div>
            <div class="vip-icon-container">
              <img class="vip-icon" src="/img/vip.png" alt="" />
              <div>{{ $t('index.video_short') }}</div>
            </div>
          </div>

          <div class="tag-list">
            <div
              v-for="(tag, tagIndex) in displayTags(item)"
              :key="tagIndex"
              class="tag-item"
            >
              {{ tr(tag) }}
            </div>
          </div>

          <div class="pay-bar">
            <div>{{ $t('index.toll') }}:</div>
            <div class="pay-star-container">
              <van-icon
                v-for="n in (item.number || 5)"
                :key="n"
                name="star"
                color="#f4b757"
                size="20"
              />
            </div>
          </div>

          <div class="girl-detail">
            {{ $t('index.height') }}: {{ item.hight }}cm {{ $t('index.bust') }}：{{ item.bust }} {{ $t('index.age') }}：{{ item.age || 21 }} {{ $t('index.address') }}：{{ item.address || item.city || $t('index.yes') }}
          </div>

          <div class="girl-button" @click.stop="toDetail(item.id, idx)">
            {{ $t('index.about') }}
          </div>
        </div>
      </div>
      </template>
    </div>

    <div class="bottom-spacer"></div>
  </div>
</template>

<script>
import { getCurrentLang, getLangFromLocale, translateCN } from '../../common/lang';
import { getHomeRecommendImage } from '../../common/homeRecommendImages';

export default {
  data() {
    return {
      notice: this.$t('index.welcome_notice'),
      hasToken: false,
      basicData: [],
      datalist: [],
      recommendLoading: true,
      banners: [{}],
      defaultTags: [
        '#Highly recommended❤️',
        '#Top model figure! ❤️',
        '#college student❤️',
        ' Abalone',
      ],
      bannerSwiperOption: {
        autoplay: { delay: 4000, disableOnInteraction: false },
        speed: 800,
        loop: true,
      },
      quickNavItems: [
        {
          path: '/Withdraw',
          icon: 'https://ik.imagekit.io/ixcx8adghm/%E4%B8%8B%E8%BD%BD%20(28).png',
        },
        {
          path: '/ServiceOnline',
          icon: 'https://ik.imagekit.io/ixcx8adghm/%E4%B8%8B%E8%BD%BD%20(37).png',
        },
        {
          path: '/ChooseEntry',
          icon: 'https://ik.imagekit.io/ixcx8adghm/%E4%B8%8B%E8%BD%BD%20(36).png',
        },
        {
          path: '/Mine',
          icon: 'https://ik.imagekit.io/ixcx8adghm/%E4%B8%8B%E8%BD%BD%20(39).png',
        },
      ],
    };
  },
  methods: {
    tr(text) {
      return translateCN(text);
    },
    displayTags(item) {
      if (item && Array.isArray(item.flagArray) && item.flagArray.length > 0) {
        return item.flagArray.slice(0, 4);
      }
      return this.defaultTags;
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config',
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getHotLottery() {
      this.$http({
        method: 'get',
        url: 'lottery_hot',
      }).then(() => {});
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = data.notice || this.$t('index.welcome_notice');
    },
    toDetail(id, idx) {
      const query = { id };
      if (idx != null && idx !== '') {
        query.idx = String(idx);
      }
      this.$router.push({ path: '/Profile', query });
    },
    checkToken() {
      this.hasToken = !!localStorage.getItem('token');
    },
    getxuanfeilist() {
      this.recommendLoading = true;
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: 1, page: 1 },
      })
        .then((res) => {
          if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
            this.datalist = res.data.map((item, index) => ({
              ...item,
              img_url: item.img_url || getHomeRecommendImage(index),
            }));
            const langMap = {
              zh: 0,
              en: 1,
              ja: 2,
              de: 1,
              kr: 1,
              mn: 0,
              es: 1,
            };
            const locale = (this.$i18n && this.$i18n.locale) || null;
            const currentLang = locale ? getLangFromLocale(locale) : getCurrentLang();
            const langIndex = langMap[currentLang] || 1;

            this.datalist.forEach((item) => {
              if (item.flag) {
                const parts = item.flag.split('|');
                item.flag = parts[langIndex] || parts[0];
                item.flagArray = item.flag ? item.flag.split('，') : [];
              } else {
                item.flagArray = [];
              }
            });
          } else {
            this.datalist = [];
          }
        })
        .catch(() => {
          this.datalist = [];
        })
        .finally(() => {
          this.recommendLoading = false;
        });
    },
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery();
  },
};
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100vh;
  background: #f3f3f5;
  padding-bottom: 60px;
}

.home-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
}

.home-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.home-header-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
}

.home-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #e89ab3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-header-right {
  flex-shrink: 0;
  padding: 4px;
}

.banner-wrap {
  padding: 0 12px;
  margin-top: 4px;
}

.banner_swiper {
  border-radius: 12px;
  overflow: hidden;
  height: 260px;
}

:deep(.banner_swiper .swiper-slide) {
  height: 260px;
}

.banner_img {
  display: block;
  width: 100%;
  height: 260px;
}

:deep(.banner_img .van-image__img),
:deep(.banner_img .van-image__loading),
:deep(.banner_img .van-image__error) {
  width: 100%;
  height: 260px;
}

:deep(.banner_img .van-image__img) {
  object-fit: cover;
}

.banner-fallback {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.notice-wrap {
  padding: 10px 12px 0;
}

.notice-bar {
  height: 36px;
  font-size: 13px;
  border-radius: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

:deep(.notice-bar .van-notice-bar__left-icon) {
  margin-right: 8px;
}

.quick-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 16px 12px;
  margin: 10px 12px 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.quick-nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(232, 154, 179, 0.08);
  cursor: pointer;
}

.quick-nav-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.recommend-section {
  padding: 0 10px;
}

.recommend-loader-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  padding: 48px 0;
}

.loader {
  height: 50px;
  width: 50px;
  background: transparent;
  border: red 3px solid;
  border-top: transparent;
  border-radius: 50%;
  animation: animate81323 0.8s linear infinite;
}

@keyframes animate81323 {
  0% {
    border: 3px solid rgb(255, 75, 75);
    border-top: transparent;
    border-left: transparent;
    transform: rotate(0deg);
  }

  50% {
    border: 3px dashed rgb(240, 41, 240);
    border-top: transparent;
    border-left: transparent;
    transform: rotate(270deg);
  }

  100% {
    border: 3px dotted rgb(28, 228, 28);
    border-top: transparent;
    border-left: transparent;
    transform: rotate(360deg);
  }
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0 6px;
  padding-left: 4px;
}

.section-title-bar {
  width: 4px;
  height: 18px;
  background: #e89ab3;
  border-radius: 2px;
  flex-shrink: 0;
}

.section-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.yp-item {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  padding: 12px 0;
  cursor: pointer;
}

.yp-img-container {
  flex: 0 0 46%;
  max-width: 46%;
  margin-right: 12px;
}

.yp-photo {
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
}

.yp-photo .top-ribbon {
  position: absolute;
  z-index: 9;
  top: 14px;
  right: -26px;
  width: 90px;
  text-align: center;
  background-color: #ebcaaf;
  color: #8d684b;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  transform: rotate(45deg);
}

.yp-img {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  object-fit: cover;
  display: block;
}

.yp-name {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 8px;
}

.yp-info {
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.vip-row {
  display: flex;
}

.vip-icon-container {
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  padding: 5px 12px;
  font-size: 13px;
  border-radius: 10px 0 10px 0;
  margin-right: 8px;
}

.vip-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  margin-right: 4px;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 0;
  column-gap: 8px;
  row-gap: 8px;
}

.tag-item {
  padding: 5px 12px;
  color: #fff;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.3;
}

.tag-item:nth-child(n) {
  background-color: #fe257f;
}

.tag-item:nth-child(2n) {
  background-color: #ff9702;
}

.tag-item:nth-child(3n) {
  background-color: #0fa7fe;
}

.pay-bar {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 15px;
}

.pay-star-container {
  display: flex;
  align-items: center;
  padding-left: 6px;
}

.girl-detail {
  color: #999;
  width: 100%;
  font-size: 13px;
  white-space: nowrap;
  word-break: keep-all;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 6px 0 10px;
  box-sizing: border-box;
}

.girl-button {
  background-image: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 26px;
  padding: 18px 10px;
  width: 100%;
  margin-top: auto;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  user-select: none;

  &:active {
    opacity: 0.85;
  }
}

.bottom-spacer {
  height: 20px;
}
</style>
